import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import Video from '../Video';
import css from './Footer.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Footer = function Footer(_ref) {
  var title = _ref.title,
      cta = _ref.cta,
      url = _ref.url,
      posterDesktop = _ref.posterDesktop,
      posterMobile = _ref.posterMobile,
      videoDesktop = _ref.videoDesktop,
      videoMobile = _ref.videoMobile;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Video, {
      className: cc([css.video, css.desktop]),
      poster: posterDesktop,
      src: videoDesktop
    }), /*#__PURE__*/_jsx(Video, {
      className: cc([css.video, css.mobile]),
      poster: posterMobile,
      src: videoMobile
    }), /*#__PURE__*/_jsxs("div", {
      className: css.foreground,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.spacer
      }), /*#__PURE__*/_jsx("h2", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: css.spacer,
        children: /*#__PURE__*/_jsx(ButtonLink, {
          className: css.link,
          white: true,
          big: true,
          medium: true,
          href: url,
          children: cta
        })
      })]
    })]
  });
};

Footer.propTypes = {
  title: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  posterDesktop: PropTypes.string.isRequired,
  posterMobile: PropTypes.string.isRequired,
  videoDesktop: PropTypes.string.isRequired,
  videoMobile: PropTypes.string.isRequired
};
export default Footer;